import React from "react";
import { Trophy, Users, Zap, TrendingUp } from "lucide-react";
import { motion } from "framer-motion";

const features = [
  {
    icon: Trophy,
    title: "Certified Excellence",
    description: "Certificates from top institutions recognized globally.",
  },
  {
    icon: Zap,
    title: "1:1 Mentorship",
    description: "Live guidance from industry professionals.",
  },
  {
    icon: Users,
    title: "Supportive Community",
    description: "Learn with peers, collaborate & grow together.",
  },
  {
    icon: TrendingUp,
    title: "Career Growth",
    description: "Placement support, mock interviews & job referrals.",
  },
];

const WhyChooseUsCollage = () => {
  return (
    <section className="bg-white py-12 md:py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        
        {/* Headings */}
        <div className="text-center mb-12 md:mb-16">
          <span className="text-blue-600 text-xs md:text-sm font-semibold tracking-wide uppercase">
            Your Learning Partner
          </span>
          <h2 className="text-3xl md:text-5xl font-extrabold font-aligran text-gray-900 mt-2">
            Why Choose Us
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">

          {/* ---------- LEFT IMAGE COLLAGE ---------- */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="relative mx-auto w-fit mb-10 lg:mb-0"
          >
            {/* Background Gradient Shape */}
            <div className="absolute -inset-4 bg-gradient-to-br from-red-500 to-blue-600 blur-3xl opacity-20 rounded-3xl"></div>

            {/* Main Image */}
            <div className="relative w-60 h-60 md:w-72 md:h-72 bg-white shadow-xl rounded-2xl overflow-hidden border border-gray-100">
              <img
                src="https://freepngimg.com/thumb/software_development/5-2-software-development-free-download-png.png"
                alt="IT Training and Software Development Excellence"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>

            {/* Small Floating Image */}
            <div className="absolute -top-6 -left-6 md:-left-10 w-24 h-24 md:w-32 md:h-32 shadow-xl rounded-full overflow-hidden border-4 border-white z-10">
              <img
                src="https://mentorloop.com/wp-content/uploads/2024/09/zarin-NSW-1024x1017.png"
                alt="1-on-1 Expert Mentorship and Career Guidance"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>

            {/* Bottom small image */}
            <div className="absolute -bottom-4 -right-6 md:-right-10 w-28 h-24 md:w-36 md:h-28 rounded-xl overflow-hidden shadow-lg border-4 border-white z-10">
              <img
                src="https://i.pinimg.com/originals/4a/43/8b/4a438b730ffa36c9285b75b6a58c9a5f.jpg"
                alt="Dedicated Student Support and Placements"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </motion.div>

          {/* ---------- RIGHT FEATURES LIST ---------- */}
          <div className="space-y-8 md:space-y-10">
            {features.map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.15 }}
                className="flex items-start group"
              >
                {/* Icon Box */}
                <div className="p-3 md:p-4 text-white rounded-xl shadow-md bg-red-800 transition-all flex-shrink-0 group-hover:scale-110">
                  <item.icon className="w-5 h-5 md:w-6 md:h-6" aria-hidden="true" />
                </div>
                <div className="ml-4 md:ml-5 font-aligran">
                  <h3 className="text-xl md:text-2xl font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm md:text-lg mt-1 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsCollage;